<template>
  <div>
    <b-col>
      <h2 class="bronzeclaro">Sobre</h2>
      <p> A Lucchese Computação e Estatística é uma empresa familiar. </p>
      <p>Com mais de 30 anos de experiência, muitas soluções em sistemas informatizados já foram trazidas aos nossos clientes ao longo das mais de três décadas de existência.</p>
      <p>Temos compromisso em trazer para os clientes soluções adaptadas as suas necessidades, com um suporte pessoal e atencioso, e valor acessível.</p>
      <p>Acessibilidade e inclusão são levadas em consideração nas nossas soluções, favorecendo a usabilidade por meio de clientes e colaboradores de vivências e hábitos diversos.</p>
      <p>Acreditamos que o sistema deve adaptar-se e trazer comodidade aos clientes e colaboradores, contribuindo para a qualidade do serviço oferecido pela empresa.</p>
      <p>É com estes valores que construímos nossas soluções empresariais em sistemas informatizados, especialmente para nossos clientes.</p>
      <router-link to="/contato" class="linkbold">Contato</router-link>
    </b-col>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>